




















import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin } from "../../mixins";
import { IConfiguration } from "../../../../../domain/configuration";

@Component
export default class FormatObjectOrderTool extends Mixins(ModelEditableMixin, FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin) {
  $configuration!: IConfiguration;

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  confirmAndRemove() {
    this.getCommonComponents().getObjectsRemover().confirmAndRemove();
  }
}
